import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';

import API from 'configs/API';

/**
 * @param {object} params - query params (e.g. user_uuid, share_link_id)
 * @param {{ useExcludingSoldDonated?: boolean }} options - collector My Page: list without sold/donated_gifted
 */
const useGalleryArtworks = (params, options = {}) => {
  const { useExcludingSoldDonated = false } = options;
  const [searchParams] = useSearchParams();
  const objectParamsFromSearchParams = Object.fromEntries(searchParams);

  const _params = {
    ...objectParamsFromSearchParams,
    ...params,
  };

  const endpoint = useExcludingSoldDonated
    ? API.ARTWORK.LIST_ARTWORK_EXCLUDING_SOLD_DONATED_GIFTED
    : API.ARTWORK.LIST_GALLERY_ARTWORK;

  return useQuery({
    queryKey: [endpoint, _params],
  });
};

export default useGalleryArtworks;
